/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Formik, Form } from 'formik';
import { Loader } from 'ypf-pas-general-ui-components';
import * as Yup from 'yup';

import {
  getUbicationDetail,
  getUbicationDetailOyM
} from '../../../../../adapters/requestServiceDetails/requestServiceDetailsAdapter';
import useToast from '../../../../../hooks/useToast';
import { TypeAndObjectImputationPermissions } from '../../../../../components/MonthlyServiceRequest/RequestDetailTypes';
import { DetailRequest } from '../../../../../utils/globalPropTypes';
import AccountAssignmentObject from '../../../../../components/AccountAssignmentObject/AccountAssignmentObject';

const ImputationObjectDetail = ({
  form,
  details,
  isOyM,
  tpyeAndObjectImputationPermissions,
  disabledEditStateCancelOrFinish,
  fromPteAuthorization,
  setHasError,
  setDisabledActions
}) => {
  const [loading, setLoading] = useState(true);
  const { setNewToast } = useToast();
  const { id } = useParams();
  const initialValues = {
    ubication: {
      ubicationType: details?.tipoUbicacion?.id,
      id: details?.idLocacion
    },
    uunn: {
      id: details?.unidadNegocio?.id
    },
    imputationObject: {
      wells: [],
      wellsCopy: []
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      let data = [];

      if (isOyM) {
        data = await getUbicationDetailOyM(id);
      } else {
        data = await getUbicationDetail(id);
      }
      const wells = {
        editaPozosLocacion: data.imputationObject?.editaPozosLocacion,
        esSoloAprobador: data.imputationObject?.esSoloAprobador,
        wells: data.imputationObject?.wells,
        copyWells: data.imputationObject?.wells
      };

      form.current.setFieldValue('imputationObject', wells);
      if (data) {
        setLoading(false);
      }
    } catch (error) {
      const message = error.response.data?.errorMessag;

      setNewToast({
        type: 'ERROR',
        message
      });
    } finally {
      setLoading(false);
    }

    return null;
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const validationSchema = Yup.object().shape({
    imputationObject: Yup.object().shape({
      wells: Yup.array().of(
        Yup.object().shape({
          well: Yup.object()
            .test('wellDuplicate', 'El pozo ya fue agregado', (item, data) => {
              const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
              let error = true;
              const indexInput = Number(data.path.split('[')[1][0]);

              wellsArray?.forEach((well, i) => {
                if (well?.well?.label === item?.label && i !== indexInput) {
                  error = false;
                }
              });

              return error;
            })
            .nullable()
            .required('Ingrese un pozo'),
          event: Yup.object()
            .test('eventDiff', 'Ingrese el mismo evento para todos los pozos', (item, data) => {
              const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
              let error = true;
              const indexInput = Number(data.path.split('[')[1][0]);
              // El id es propio del evento
              // se mapea que value ahora es eventoPozoId
              // (lo cual esto es propio de la relación Evento-Pozo)
              // EventoPozoId y id evento son diferentes siempre
              const eventDiff = wellsArray?.some(
                (well, i) => well?.event?.id !== item?.id && i !== indexInput
              );

              if (item?.id) {
                if (eventDiff) {
                  error = false;
                }
              }

              return error;
            })
            .nullable()
            .required('Seleccione un evento'),
          team: Yup.object().nullable().required('Seleccione un equipo'),
          imputationType: Yup.object().nullable().required('Seleccione un tipo de imputación'),
          imputationObject: Yup.object().nullable().required('Seleccione un objeto de imputación'),
          state: Yup.string(),
          budget: Yup.string().nullable(),
          idSolicitudServicioPozo: Yup.string().nullable(),
          logisticCenter: Yup.string().nullable(),
          socCode: Yup.string().nullable(),
          soc: Yup.array().of(Yup.string()).nullable(),
          add: Yup.bool(),
          editable: Yup.bool()
        })
      )
    })
  });

  return (
    <Formik initialValues={initialValues} innerRef={form} validationSchema={validationSchema}>
      {() => (
        <>
          {loading && <Loader show text="CARGANDO ..." />}
          <Form>
            <AccountAssignmentObject
              bussinesUnitId={details?.unidadNegocio.id}
              disabledAddWell={!tpyeAndObjectImputationPermissions.editWells}
              disabledImputationForm={!tpyeAndObjectImputationPermissions.editObjectImputation}
              eventId={details?.eventoPozoId}
              formRef={form}
              fromPteAuthorization={fromPteAuthorization}
              imputationObjectDefault={!tpyeAndObjectImputationPermissions.editObjectImputation}
              locationId={details?.idLocacion}
              maxCantWells={0}
              readOnly={disabledEditStateCancelOrFinish}
              setDisabledActions={setDisabledActions}
              setHasError={setHasError}
              showDetailWell
              typeOfEventId={form?.current?.values?.imputationObject?.wells[0]?.event?.id}
              ubicationType={details?.tipoUbicacion}
            />
          </Form>
        </>
      )}
    </Formik>
  );
};

ImputationObjectDetail.propTypes = {
  details: DetailRequest,
  form: PropTypes.objectOf(PropTypes.any),
  isOyM: PropTypes.bool,
  tpyeAndObjectImputationPermissions: TypeAndObjectImputationPermissions.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  fromPteAuthorization: PropTypes.bool,
  setHasError: PropTypes.func,
  setDisabledActions: PropTypes.func
};

ImputationObjectDetail.defaultProps = {
  form: {},
  isOyM: false,
  details: null,
  fromPteAuthorization: false,
  setHasError: () => {},
  setDisabledActions: () => {}
};

export default ImputationObjectDetail;
